import { render, staticRenderFns } from "./yuesaoBox.vue?vue&type=template&id=4fcf739a&lang=html&"
import script from "./yuesaoBox.vue?vue&type=script&lang=js&"
export * from "./yuesaoBox.vue?vue&type=script&lang=js&"
import style0 from "./yuesaoBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports